<div style="display: block;align-items: center;clear: both;margin-bottom: 10px;overflow: hidden;background: #EEE;">
  <ul class="menu-top" nz-menu nzMode="horizontal" style="float: left">
    <li nz-menu-item routerLinkActive="menu-item-active">
      <a routerLink="/admin/warehouse-hub/inventory" routerLinkActive="active">
        <span class="fa fa-file-alt"></span>
        Tồn kho
      </a>
    </li>
    <li nz-menu-item *ngIf="isMaster" routerLinkActive="menu-item-active">
      <a routerLink="/admin/warehouse-hub/import" routerLinkActive="active">
        <span class="fa fa-file-import"></span>
        Nhập kho
      </a>
    </li>
    <li nz-menu-item *ngIf="isAbleToConfirmed" routerLinkActive="menu-item-active">
      <a routerLink="/admin/warehouse-hub/confirm-import" routerLinkActive="active">
        <span class="fa fa-file-import"></span>
        Xác nhận nhập kho
      </a>
    </li>
    <li nz-menu-item routerLinkActive="menu-item-active">
      <a *ngIf="isMaster" routerLink="/admin/warehouse-hub/export" routerLinkActive="active">
        <span class="fa fa-recycle fa-fw"></span>
        Xuất điều chuyển
      </a>
      <a *ngIf="isLab" routerLink="/admin/warehouse-hub/export" routerLinkActive="active">
        <span class="fa fa-recycle fa-fw"></span>
        Xuất kho
      </a>
    </li>
    <li nz-menu-item routerLinkActive="menu-item-active" *ngIf="isLab">
      <a routerLink="/admin/warehouse-hub/export-machine" routerLinkActive="active">
        <span class="fa fa-user-cog"></span>
        Xuất cho máy XN
      </a>
    </li>
    <li nz-menu-item routerLinkActive="menu-item-active">
      <a routerLink="/admin/warehouse-hub/kiem-ke" routerLinkActive="active">
        <span class="fa fa-check-circle fa-fw"></span>
        Kiểm kê
      </a>
    </li>
    <li *ngIf="isMaster" nz-menu-item routerLinkActive="menu-item-active">
      <a routerLink="/admin/warehouse-hub/xuat-kho" routerLinkActive="active">
        <span class="fa fa-file-export"></span>
        Xuất kho
      </a>
    </li>
    <li nz-menu-item routerLinkActive="menu-item-active">
      <a routerLink="/admin/warehouse-hub/chemical-log" routerLinkActive="active">
        <span class="fa fa-search fa-fw"></span>
        Tra cứu vật tư
      </a>
    </li>
  </ul>
  <div style="float: right;margin-top: 5px;">
    <label>Kho thao tác: </label>
    <nz-select style="width: 200px;margin-left: 5px"
               nzShowSearch (ngModelChange)="changeWarehouse($event)"
               [(ngModel)]="selectedWarehouseId"
               nzPlaceHolder="Chọn kho làm việc" class="input-search"
               [nzShowArrow]="true">
      <nz-option  nzCustomContent *ngFor="let o of warehouses" nzLabel="{{o.name}}" [nzValue]="o.id">
        {{o.name}}
      </nz-option>
    </nz-select>
  </div>
</div>

